import { Card, CardContent } from '@/components/ui/card';
import { ArrowDown, ArrowUp, Minus } from 'lucide-react';
import { cn } from '@/lib/utils';

interface KpiCardProps {
  label: string;
  value: string | number;
  hint?: string;
  delta?: number | null;
  icon?: React.ReactNode;
  accent?: 'primary' | 'success' | 'warning' | 'info' | 'accent';
}

export function KpiCard({ label, value, hint, delta, icon, accent = 'primary' }: KpiCardProps) {
  const deltaColor =
    delta == null ? 'text-muted-foreground'
    : delta > 0 ? 'text-success'
    : delta < 0 ? 'text-destructive'
    : 'text-muted-foreground';

  const DeltaIcon = delta == null ? Minus : delta > 0 ? ArrowUp : delta < 0 ? ArrowDown : Minus;

  const accentBg: Record<string, string> = {
    primary: 'bg-primary/10 text-primary',
    success: 'bg-success/10 text-success',
    warning: 'bg-warning/10 text-warning',
    info: 'bg-info/10 text-info',
    accent: 'bg-accent/10 text-accent',
  };

  return (
    <Card className="glass-card">
      <CardContent className="p-5">
        <div className="flex items-start justify-between mb-3">
          <p className="text-xs font-medium uppercase tracking-wider text-muted-foreground">{label}</p>
          {icon && (
            <div className={cn('w-8 h-8 rounded-lg flex items-center justify-center', accentBg[accent])}>
              {icon}
            </div>
          )}
        </div>
        <p className="text-3xl font-bold text-foreground">{value}</p>
        <div className="flex items-center gap-2 mt-2">
          {delta != null && (
            <span className={cn('flex items-center gap-0.5 text-xs font-semibold', deltaColor)}>
              <DeltaIcon className="w-3 h-3" />
              {Math.abs(delta).toFixed(1)}%
            </span>
          )}
          {hint && <span className="text-xs text-muted-foreground">{hint}</span>}
        </div>
      </CardContent>
    </Card>
  );
}
